import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative me-1 mr-2" }
const _hoisted_5 = { class: "d-flex px-8" }
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary dropdown-toggle",
  type: "button",
  id: "dropdownMenu2",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Sorting ", -1)
const _hoisted_8 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenu2"
}
const _hoisted_9 = { class: "card-toolbar" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex align-items-center position-relative me-1 ml-3"
}
const _hoisted_11 = { class: "card-title align-items-start flex-column" }
const _hoisted_12 = {
  key: 3,
  class: "d-flex align-items-center position-relative my-1"
}
const _hoisted_13 = { class: "card-title align-items-start flex-column" }
const _hoisted_14 = { class: "card-header border-0" }
const _hoisted_15 = { class: "card-toolbar" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "mt-2 col-12 col-md-4" }
const _hoisted_18 = { class: "mt-2 col-12 col-md-3" }
const _hoisted_19 = { class: "mt-2 col-12 col-md-3" }
const _hoisted_20 = {
  key: 0,
  class: "mt-2 col-12 col-md-3"
}
const _hoisted_21 = { class: "mt-2 col-12 col-md-3" }
const _hoisted_22 = { class: "mt-2 col-12 col-md-3" }
const _hoisted_23 = {
  class: "modal fade",
  ref: "downloadModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_migrasi"
}
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-dialog modal-dialog-centered mw-600px\"><div class=\"modal-content rounded\"><div class=\"modal-header py-2 border-0 justify-content-start\" style=\"background-color:#00a29c;\"><label class=\"fw-bold fs-2\" style=\"color:white;\">Migrasi PPDB</label></div><div class=\"modal-body scroll-y px-10 px-lg-15 pt-0 pb-5\"><div class=\"pt-8\"><h3 class=\"text-black\"> Apakah anda yakin akan melakukan migrasi sekolah untuk menggunakan fitur PPDB? </h3></div><div class=\"modal-footer\"><div class=\"m-2\" style=\"width:100%;text-align:center;\"><button style=\"width:20%;\" type=\"button\" class=\"btn btn-success\" data-bs-dismiss=\"modal\"> Ya </button>      <button style=\"width:20%;\" type=\"button\" class=\"btn btn-danger\" data-bs-dismiss=\"modal\"> Tidak </button></div></div></div></div></div>", 1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "card-body py-3" }
const _hoisted_27 = { class: "table-responsive" }
const _hoisted_28 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-110px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Siswa"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Sales"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Implementator"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Dibuat"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Migrasi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-2" }, "Aksi")
  ])
], -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "text-left" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-left" }
const _hoisted_34 = { class: "text-left" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_37 = {
  key: 1,
  class: "badge badge-light"
}
const _hoisted_38 = {
  key: 2,
  class: "badge badge-secondary"
}
const _hoisted_39 = {
  key: 3,
  class: "badge badge-info"
}
const _hoisted_40 = {
  key: 4,
  class: "badge badge-warning"
}
const _hoisted_41 = {
  key: 5,
  class: "badge badge-danger"
}
const _hoisted_42 = {
  key: 6,
  class: "badge badge-success"
}
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_46 = {
  key: 1,
  class: "badge badge-secondary"
}
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/migrasi.svg",
  alt: ""
}, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/migrasi.svg",
  alt: ""
}, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/mig.svg",
  alt: ""
}, null, -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { class: "row mt-5 mb-5" }
const _hoisted_73 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_74 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_75 = ["label", "value"]
const _hoisted_76 = { class: "p-3" }
const _hoisted_77 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_78 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_UploadSekolah = _resolveComponent("UploadSekolah")!
  const _component_DownloadSekolah = _resolveComponent("DownloadSekolah")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.idBank,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.idBank) = $event)),
              placeholder: "Pilih Bank",
              mode: "single",
              "create-option": false,
              options: _ctx.listBank,
              searchable: true,
              label: "name",
              "track-by": "name",
              "value-prop": "_id",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pilihBank($event)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortingFunc('sort=name&dir=1'))),
                    type: "button"
                  }, " Nama A-Z ")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortingFunc('sort=name&dir=-1'))),
                    type: "button"
                  }, " Nama Z-A ")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortingFunc('sort=createTime&dir=-1'))),
                    type: "button"
                  }, " Tanggal Terbaru ")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortingFunc('sort=createTime&dir=1'))),
                    type: "button"
                  }, " Tanggal Terlama ")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (
            _ctx.role != 'IMPLEMENTATOR_LEADER' &&
            _ctx.role != 'IMPLEMENTATOR_MEMBER' &&
            _ctx.role != 'ADMIN_CARD' &&
            _ctx.role != 'ADMIN_LEGAL' &&
            _ctx.role != 'CS_LEADER' &&
            _ctx.role != 'CS_MEMBER' &&
            _ctx.role != 'MARKETING_LEADER' &&
            _ctx.role != 'MARKETING_MEMBER'
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("h3", _hoisted_11, [
                  _createElementVNode("a", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/superadmin/sekolah/add'))),
                    class: "btn btn-md btn-primary"
                  }, " Tambah Data ")
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.role != 'ADMIN_CARD' &&
            _ctx.role != 'CS_LEADER' &&
            _ctx.role != 'CS_MEMBER' &&
            _ctx.role != 'MARKETING_LEADER' &&
            _ctx.role != 'MARKETING_MEMBER'
          )
            ? (_openBlock(), _createBlock(_component_UploadSekolah, { key: 1 }))
            : _createCommentVNode("", true),
          (_ctx.role != 'ADMIN_CARD')
            ? (_openBlock(), _createBlock(_component_DownloadSekolah, { key: 2 }))
            : _createCommentVNode("", true),
          (_ctx.role != 'ADMIN_LEGAL' && _ctx.role != 'ADMIN_CARD')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("h3", _hoisted_13, [
                  _createElementVNode("a", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/superadmin/sekolah/history-upload'))),
                    class: "btn btn-md btn-success"
                  }, " History Upload Data ")
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Field, {
                type: "text",
                placeholder: "Nama",
                class: "form-control text-center",
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.name) = $event)),
                onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changePageSize($event)))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.salesArea,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.salesArea) = $event)),
                placeholder: "Sales",
                mode: "single",
                "create-option": false,
                options: _ctx.user_sales_area,
                searchable: true,
                label: "name",
                "track-by": "name",
                "value-prop": "_id",
                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.pilihSalesArea($event)))
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.implementator,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.implementator) = $event)),
                placeholder: "Implementator",
                mode: "single",
                "create-option": false,
                options: _ctx.user_implementator,
                searchable: true,
                label: "name",
                "track-by": "name",
                "value-prop": "_id",
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.pilihImplementator($event)))
              }, null, 8, ["modelValue", "options"])
            ]),
            (
              _ctx.role != 'IMPLEMENTATOR_LEADER' &&
              _ctx.role != 'IMPLEMENTATOR_MEMBER' &&
              _ctx.role != 'CS_LEADER' &&
              _ctx.role != 'CS_MEMBER'
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.schoolStatus,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.schoolStatus) = $event)),
                    placeholder: "Status",
                    mode: "single",
                    "create-option": false,
                    options: _ctx.comboSchoolStatus,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "_id",
                    onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.pilihSchoolStatus($event)))
                  }, null, 8, ["modelValue", "options"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.isMigratePsp,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isMigratePsp) = $event)),
                placeholder: "Status Migrasi",
                mode: "single",
                "create-option": false,
                options: _ctx.comboIsMigratePsp,
                searchable: true,
                label: "name",
                "track-by": "name",
                "value-prop": "_id",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.pilihIsMigratePsp($event)))
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_ctx.aksescombostatus == true)
                ? (_openBlock(), _createBlock(_component_Multiselect, {
                    key: 0,
                    modelValue: _ctx.schoolStatus,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.schoolStatus) = $event)),
                    placeholder: "Status",
                    mode: "single",
                    "create-option": false,
                    options: _ctx.comboIsMigratePspstatus,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "_id",
                    onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.pilihIsMigratePspstatus($event)))
                  }, null, 8, ["modelValue", "options"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, _hoisted_25, 512),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("table", _hoisted_28, [
            _hoisted_29,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_31, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(item.studentCount), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(item.salesAreaName), 1),
                      _createElementVNode("td", _hoisted_34, _toDisplayString(item.listImplementatorName), 1),
                      _createElementVNode("td", _hoisted_35, [
                        (item.status == 'Leads')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, " Leads "))
                          : _createCommentVNode("", true),
                        (item.status == 'Waiting')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, " Menunggu "))
                          : _createCommentVNode("", true),
                        (item.status == 'Process')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, " Proses "))
                          : _createCommentVNode("", true),
                        (item.status == 'Closing')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, " Closing "))
                          : _createCommentVNode("", true),
                        (item.status == 'Pending')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, " Pending "))
                          : _createCommentVNode("", true),
                        (item.status == 'Cancel')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, " Batal "))
                          : _createCommentVNode("", true),
                        (item.status == 'Live')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, " Live "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatDate(item.createTime)), 1),
                      _createElementVNode("td", _hoisted_44, [
                        (item.isMigratePsp === true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, " Sudah "))
                          : _createCommentVNode("", true),
                        (item.isMigratePsp === false)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, " Belum "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_47, [
                        (_ctx.role != 'ADMIN_CARD')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "symbol symbol-30px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Detail",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (
                      _ctx.$router.push('/superadmin/sekolah/detail/' + item._id)
                    )
                            }, _hoisted_50, 8, _hoisted_48))
                          : _createCommentVNode("", true),
                        (
                      _ctx.role != 'CS_LEADER' &&
                      _ctx.role != 'CS_MEMBER' &&
                      _ctx.role != 'MARKETING_LEADER' &&
                      _ctx.role != 'MARKETING_MEMBER'
                    )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "symbol symbol-30px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Edit",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (
                      _ctx.$router.push('/superadmin/sekolah/edit/' + item._id)
                    )
                            }, _hoisted_53, 8, _hoisted_51))
                          : _createCommentVNode("", true),
                        (item.isMigratePsp == true && _ctx.role === 'SUPER_ADMIN')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              class: "symbol symbol-30px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Hapus",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.handleDeleteMigrationTrue(index, item))
                            }, _hoisted_56, 8, _hoisted_54))
                          : _createCommentVNode("", true),
                        (item.isMigratePsp == false && _ctx.role === 'SUPER_ADMIN')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 3,
                              class: "symbol symbol-30px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Hapus",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.handleDelete(index, item))
                            }, _hoisted_59, 8, _hoisted_57))
                          : _createCommentVNode("", true),
                        (
                      item.isMigratePsp == true &&
                      (_ctx.role === 'SUPER_ADMIN' ||
                        _ctx.role === 'IMPLEMENTATOR_LEADER' ||
                        _ctx.role === 'IMPLEMENTATOR_MEMBER')
                    )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 4,
                              class: "symbol symbol-30px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Sekolah Sudah Terdaftar di PSP",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.migrationTrue(index, item))
                            }, _hoisted_62, 8, _hoisted_60))
                          : _createCommentVNode("", true),
                        (
                      item.isMigratePsp == false &&
                      (_ctx.role === 'SUPER_ADMIN' ||
                        _ctx.role === 'IMPLEMENTATOR_LEADER' ||
                        _ctx.role === 'IMPLEMENTATOR_MEMBER')
                    )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 5,
                              class: "symbol symbol-30px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Daftar PSP",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.migrationSchool(index, item)),
                              disabled: ""
                            }, _hoisted_65, 8, _hoisted_63))
                          : _createCommentVNode("", true),
                        (
                      item.schoolFeature.ppdb &&
                      (item.status === 'Closing' || item.status === 'Live') &&
                      !item.isMigratePpdb &&
                      _ctx.role !== 'ADMIN_CARD'
                    )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 6,
                              class: "symbol symbol-30px me-2",
                              "data-bs-toggle": "modal",
                              title: "Migrasi PPDB",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.migrationPPDB(index, item)),
                              disabled: ""
                            }, _hoisted_68, 8, _hoisted_66))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_69, _hoisted_71))
          ])
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.changePageSize($event)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item.toString(),
                      value: item
                    }, null, 8, _hoisted_75))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_76, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("ul", _hoisted_78, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}